import { PlusIcon } from '@heroicons/react/24/outline';
import { Button } from '../../components/Button';
import { Story } from '../../schema';
import { StoryBox } from './story/storyBox';

interface EditStoryListProps {
  stories: Story[];
  isCreatingStory: boolean;
  onAddStory: () => void;
  onEditStory: (story: Story) => void;
  onDeleteStory: (storyId: string) => void;
}

/**
 * Presentational component for the list of stories with add button.
 * Shows add story button and sorted story list.
 */
export const EditStoryList = ({
  stories,
  isCreatingStory,
  onAddStory,
  onEditStory,
  onDeleteStory,
}: EditStoryListProps) => {
  return (
    <div>
      <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 mt-12 flex justify-center">
        <Button
          type="button"
          variant="ghost"
          size="lg"
          className="relative rounded-lg border-2 border-dashed p-12 text-center w-64 flex-col h-auto"
          onClick={onAddStory}
          disabled={isCreatingStory}
          loading={isCreatingStory}
        >
          <PlusIcon className="mx-auto h-12 w-12 text-disabled" />
          <span className="mt-2 block text-sm font-semibold text-main">
            {isCreatingStory ? 'Creating...' : 'Add Story'}
          </span>
        </Button>
      </div>
      {[...stories]
        .sort((a, b) => {
          const dateA = new Date(a.date).getTime();
          const dateB = new Date(b.date).getTime();
          return dateB - dateA;
        })
        .map((story, index) => (
          <StoryBox
            key={story.id}
            index={index}
            story={story}
            onEdit={() => onEditStory(story)}
            deleteStory={onDeleteStory}
          />
        ))}
    </div>
  );
};
